(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-test-logger', actionFunc);

    function actionFunc($timeout, SodLogger) {
        return function() {
            const args = arguments;
            return $timeout(function() {
                SodLogger.info('ACTIONTEST LOGGER', args);
            });
        };
    }
})();